import React, { useEffect, useState, useRef } from "react";
import moment from "moment";
import { Table, Typography, Alert } from "antd";
import apiClient from "../../apis/ApiInterceptor";
import "moment/locale/es"; // Importa español para moment

// TODO: Move to a common file
moment.locale("es"); // Configura moment en español
const { Title } = Typography;

const PastSessions = ({ userId, className, refreshKey }) => {
    const [userSessions, setUserSessions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const scrollContainerRef = useRef(null); // Referencia para el scroll interno
    const isFetchingRef = useRef(false);

    useEffect(() => {
        setUserSessions([]);
        setPage(1);
        setHasMore(true);
        setError(null);
    }, [refreshKey, userId]);

    useEffect(() => {
        if (!userId) {
            setError("No se proporcionó un ID de usuario.");
            return;
        }

        const fetchUserSessions = async () => {
            if (isFetchingRef.current || !hasMore) return;
            
            isFetchingRef.current = true;
            setLoading(true);
            try {
                const response = await apiClient.get(`/users/${userId}/sessions`, { // TODO: move this to api
                    params: { past_sessions: true, page, limit: 10 },
                });

                if (response.data.length === 0) {
                    setHasMore(false);
                } else {
                    setUserSessions((prevSessions) => [...prevSessions, ...response.data]);
                }
            } catch (err) {
                setError("Error al cargar las sesiones pasadas del usuario.");
            }
            finally {
                isFetchingRef.current = false; // 🔓 UNLOCK
                setLoading(false);
            }
        };

        fetchUserSessions();
    }, [userId, page, refreshKey]); // Add refreshKey as a dependency

    /**  TODO: bug: el event listener en verdad parece que no se está añadiendo
     * Si se utiliza el scroll del Table deja de funcionar.
     * el loading no se puede quitar del siguiente useEffect o deja de cargar más data
    */
    // Detectar scroll y cargar más datos
    // Detectar scroll en el div de las sesiones (no en el `window`)
    useEffect(() => {
        const handleScroll = () => {
            const container = scrollContainerRef.current;
            if (!container) return;

            if (container.scrollTop + container.clientHeight >= container.scrollHeight - 50 && !isFetchingRef.current && hasMore) {
                setPage((prevPage) => prevPage + 1);
            }
        };

        const container = scrollContainerRef.current;
        if (container) {
            container.addEventListener("scroll", handleScroll);
        }

        return () => {
            if (container) {
                container.removeEventListener("scroll", handleScroll);
            }
        };
    }, [loading, hasMore]);

    if (error) {
        return (
            <div className={`${className} text-center`}>
                <Alert message="Error" description={error} type="error" showIcon />
            </div>
        );
    }

    if (!userSessions.length) {
        return null;
    }

    const columns = [
        {
            title: "Fecha del Evento",
            dataIndex: "start_date",
            key: "start_date",
                render: (date) => moment.utc(date).local().format("dddd D MMMM YYYY, h:mm A")
        },
        {
            title: "Clase",
            dataIndex: "name",
            key: "name",
        },
        {
            title: "Asistió",
            dataIndex: "attended",
            key: "attended",
            render: (attended) => (attended ? "✅ Sí" : "❌ No"),
        },
        {
            title: "Cancelación",
            dataIndex: "deleted_at",
            key: "deleted_at",
            render: (date) => (date ? moment.utc(date).local().format("DD-MM-YY h:mm A") : "N/A"),
        },
    ];

    return (
        <div className={`col-11 ${className}`}>
            <Title level={3} className="text-center">Últimas Sesiones</Title>
            <div
                ref={scrollContainerRef}
                style={{ maxHeight: "400px", overflowY: "auto" }}
            >
                <Table
                    dataSource={userSessions}
                    columns={columns}
                    rowKey="id"
                    pagination={false}
                    loading={loading}
                />
            </div>
        </div>
    );
};

export default PastSessions;
